<template>
  <a class="popular-service" @click.prevent="showService(data)" href="#">
    <span class="popular-service__title">
      {{ data | localeField("name") }}
    </span>
    <span
      class="popular-service__description"
      v-html="$options.filters.localeField(data, 'description')"
    ></span>
    <div class="popular-service__price">
      <span class="popular-service__price-value">
        {{ price | formatPrice }} {{ currency?.symbol }}
      </span>
      <span class="popular-service__price-quantum"> / {{ unit }} </span>
    </div>
  </a>
</template>

<script>
import { i18n } from "@v2/shared/config";
import { mapGetters } from "vuex";

export default {
  name: "PopularServiceComponent",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          prices: []
        };
      }
    }
  },
  data() {
    return {
      count: 1
    };
  },
  computed: {
    ...mapGetters("event", ["currency"]),
    currentPrice() {
      return this.data && this.data.prices && this.data.prices.length
        ? this.data.prices.find(price => price.currency === this.currency.code)
        : null;
    },
    price() {
      return this.currentPrice
        ? Number(this.currentPrice.price_with_vat)
        : "N/A";
    },
    unit() {
      if (!this.currentPrice) return "";

      return i18n.locale === "en"
        ? this.currentPrice.unit.name_eng
        : this.currentPrice.unit.name_rus;
    }
  },
  methods: {
    showService(service) {
      this.$modal.show("service-modal", { id: service.id });
    }
  }
};
</script>

<style lang="scss">
.popular-service {
  display: flex;
  flex-direction: column;
  padding: 15px;
  border: 1px solid var(--gray-darker, #d5dae5);
  background: var(--white, #fff);
  margin: 15px;
  text-decoration: none;

  &__title {
    color: var(--dark, #262626);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 22px; /* 157.143% */
    margin-bottom: 10px;
  }

  &__description {
    color: var(--dark-light, #6d7179);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 18px; /* 150% */
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: auto;
  }

  &__price {
    display: flex;
    align-items: center;
    column-gap: 5px;
    margin: 5px 0 10px;

    &-value {
      color: var(--main-dark, #005197);
      font-size: 0.875rem;
      font-weight: 700;
      line-height: 22px; /* 157.143% */
    }

    &-quantum {
      color: var(--gray-dark, #a3a8b3);
      font-size: 0.75rem;
      font-weight: 400;
      line-height: 18px; /* 150% */
    }
  }

  &__footer {
    display: flex;
    column-gap: 15px;
  }

  &__input {
    flex-grow: 1;

    @media (max-width: 999px) {
      flex-grow: 0;
    }
  }

  &__btn {
    padding: 9.5px 26px;
    white-space: nowrap;

    @media (max-width: 540px) {
      flex-grow: 1;
    }
  }
}
</style>
